import React, { useState } from 'react';
import PropTypes from 'prop-types';
import cn from 'classnames';
import Icon from '../Icon/Icon';

export const Alert = ({ alert, onAlertClose, className }) => {
  const [hidden, setHidden] = useState(false);

  const { alertTitle, alertLinkHref, alertLink } = alert;

  const hideAlert = () => {
    setHidden(true);
    setTimeout(() => {
      onAlertClose();
    }, 300);
  };

  return (
    <div
      className={cn(
        `o-grid o-grid--center o-grid--full-height c-alert-ribbon mt-gradient`,
        className,
        { 'alert-hidden': hidden }
      )}
    >
      <div className="o-grid__item u-1/2 u-text-bold">
        <span>{alertTitle}</span>
      </div>
      <div className="o-grid__item u-1/2 u-text-bold">
        <span className="c-alert__cta">
          <a href={alertLinkHref}>{alertLink}</a>{' '}
          <Icon
            icon="close"
            className="c-alert-ribbon__close"
            onClick={hideAlert}
          />
        </span>
      </div>
    </div>
  );
};

Alert.propTypes = {
  alert: PropTypes.shape({
    alertTitle: PropTypes.string.isRequired,
    alertLinkHref: PropTypes.string.isRequired,
    alertLink: PropTypes.string.isRequired,
  }).isRequired,
  onAlertClose: PropTypes.func.isRequired,
  className: PropTypes.string,
};

Alert.defaultProps = {
  className: '',
};
